import React from 'react';
import { Form, Input, Button,Spin,Select,Switch, message,Divider } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var bizuserid=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;
const { Option } = Select;


class ActionClosingForm extends React.Component {

  state = {
    name:'' ,  
    datarequested:true,
    status:'',
    message:'',


    prompt_applicant:false,
    actions:[],
    prompt_action:'',
    prompt_reason:'',
    application_formfields:[],
    auto_prompted_fields:[]

  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
      bizuserid= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/actionworkflowmappings/?workflow=${this.props.status_obj.workflow}`)
    .then(res => {
        this.setState({
          actions:res.data
        })

        this.setState({datarequested:false})
      })


      axios.get(serverconfig.backendserverurl+`/api/application_formfields/?workflow=${this.props.status_obj.workflow}`)
      .then(res => {
          this.setState({
              application_formfields:res.data
          })
          this.setState({datarequested:false})
    
      })


  }


  //submit button pressed
  handleFormSubmit=(event) =>{

    if (this.state.prompt_applicant===true && this.state.auto_prompted_fields.length<=0){
      message.error("Please select atleast one applicant prompt field")
    }else{


      this.setState({datarequested:true})
      let form_data = new FormData();
      form_data.append('status', this.state.status);
      form_data.append('message', this.state.message);
      form_data.append('action_status_id', this.props.status_obj.id);
      form_data.append('bizuserid', bizuserid);

      form_data.append('prompt_applicant', this.state.prompt_applicant);
      form_data.append('prompt_action', this.state.prompt_action);
      form_data.append('prompt_reason', this.state.prompt_reason);
      form_data.append('auto_prompted_fields',JSON.stringify(this.state.auto_prompted_fields) );

      axios.post(serverconfig.backendserverurl+'/customqueries/close_action', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    .then(res => {
      this.setState({datarequested:false})
      this.component_reloaded()

      ///refesrh
      this.props.onRefresh()

    }    

    )
    .catch(error => console.log(error))


    }


  }

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
       <Form onFinish={(event) => this.handleFormSubmit(event)}>
    
      <FormItem label="Message">
        <TextArea
            placeholder="Message"
            autoSize={{ minRows: 2, maxRows: 6 }}
            value={this.state.message}
            onChange={(val)=>{this.setState({message:val.target.value})}}
          />
      </FormItem>


      <FormItem label="Decision Result"
        name="status"
        rules={[
          {
            required: true,
            message: 'Please select',
          },
        ]}
      >
          <Select 
          placeholder="Decision Result" 
          style={{  }} 
          value={this.state.status}
          onChange={(val)=>{
            this.setState({status:val})
          }} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch} >
                <Option value={'Completed'}>{'Completed'}</Option>
                <Option value={'Failed'}>{'Failed'}</Option>
          </Select>
      </FormItem>


      <Form.Item label="Prompt Applicant" >
        <Switch
            checked={this.state.prompt_applicant}
            onChange={val=>{this.setState({prompt_applicant:val})}}
            checkedChildren="Yes"
            unCheckedChildren="No"
            />
      </Form.Item>



      {
        this.state.prompt_applicant?
          <FormItem label="Prompt Action"
          name="action"
          rules={[
            {
              required: true,
              message: 'Please select',
            },
          ]}
        >
            <Select 
            placeholder="Prompt Action" 
            style={{  }} 
            value={this.state.prompt_action}
            onChange={(val)=>{
              this.setState({prompt_action:val})
            }} 
            showSearch
            optionFilterProp="children"
            >
              {this.state.actions.map(
                (type)=>{

                  if (Number(this.props.status_obj.action)===Number(type.action)){
                   return null
                  }else{
                    return (<Option value={type.action}>{type.action_name} {' <> '} {type.order} </Option>)
                  }
                 }
                  
                 )}

            </Select>
        </FormItem>
        :
        null
      }


      {
       this.state.prompt_applicant?
       <FormItem label="Prompt Reason">
        <TextArea
          placeholder="Prompt Reason"
          autoSize={{ minRows: 2, maxRows: 6 }}
          value={this.state.prompt_reason}
          onChange={(val)=>{this.setState({prompt_reason:val.target.value})}}
        />
      </FormItem>
      :null
      }


      {
        this.state.prompt_applicant===true?
        <div>
            {
                this.state.application_formfields.length>0?
                <div style={{display:'flex',flexDirection:'column'}}>
                <h6>Select prompt fields .</h6>

                {this.state.application_formfields.map((item) => (
                  <p style={{display:'flex',flexDirection:'row'}}>
                  <Switch
                    onChange={(val) => {
                      if (val === true) {
                        var obj={
                          'id':item.id,
                          'label':item.label
                        }
                        var new_array = [
                          ...this.state.auto_prompted_fields,
                          obj,
                        ];
                        this.setState({ auto_prompted_fields: new_array });

                      } else {
                        this.setState({
                          auto_prompted_fields: [
                            ...this.state.auto_prompted_fields.filter(
                              (todo) => todo.id!== item.id
                            ),
                          ],
                        });
                      }
                      
                    }}
                    style={{marginRight:2}} 

                  ></Switch>{" "}
                  {item.label} 
                </p>

                ))}

                <Divider></Divider>
                </div>

                :
                null
              }

        </div>
        :
        null
       }


      <FormItem>
        <Button  type="primary" htmlType="submit">Close Action</Button>
      </FormItem>


       </Form>
        </div>
      );
    }

  }

}


export default ActionClosingForm;



